import { setEvents } from "../events";
import { setProductFlag, buildProductFlag } from "../pageLoad/productFlags";

let recommendedOutfitsResolve;

export const recommendedOutfitsPromise = new Promise(
  (resolve) => (recommendedOutfitsResolve = resolve),
);

export function setRecommendedOutfitsTracking({
  numOfRecProducts,
  shouldTrack = true,
}) {
  if (!shouldTrack) {
    recommendedOutfitsResolve();
    return;
  }
  if (!numOfRecProducts) {
    setProductFlag(buildProductFlag({ key: "sfy", shown: false }));
  } else {
    setProductFlag(buildProductFlag({ key: "sfy", shown: true }));
    setEvents({
      events: [`event342=${numOfRecProducts}`],
      trackingName: "postPageLoad",
    });
  }

  recommendedOutfitsResolve();
}
